import React from 'react';
import { TbCheck, TbChecks } from 'react-icons/tb';
import { useResolveThread } from '../../../../../services/comment.service';
import { queryClient } from '../../../../../config/queryClient';
import { QUERY_KEYS } from '../../../../../services/constants';
import * as Styled from './style';

interface CommentResolvedStateProps {
  threadID?: string | null;
  isResolved?: boolean;
  refetchComments: () => Promise<unknown>;
}

const CommentResolvedState = ({
  threadID,
  isResolved = false,
  refetchComments
}: CommentResolvedStateProps) => {
  const resolveThreadMutation = useResolveThread();

  const handleResolveThread = (e: React.MouseEvent<SVGElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (!threadID) return;

    resolveThreadMutation.mutate(
      { threadID },
      {
        onSuccess: () => {
          queryClient.refetchQueries({
            queryKey: [QUERY_KEYS.GET_ALL_COMMENTS, 'REPORT_COMMENTS'],
            exact: false
          });
          refetchComments();
        }
      }
    );
  };

  if (!threadID) return null;

  if (isResolved) {
    return (
      <Styled.ResolvedState id={`comment-resolved-state-${threadID}`} className="resolved-thread">
        <TbChecks color="#2F9E44" fontSize={18} /> Resolved
      </Styled.ResolvedState>
    );
  }

  return (
    <TbCheck
      id={`comment-unresolved-state-${threadID}`}
      className="unresolved-thread"
      color="#868E96"
      fontSize={18}
      cursor="pointer"
      onClick={handleResolveThread}
    />
  );
};

export default CommentResolvedState;
